import { useCallback, useRef, useState } from "react";
import { useAnyOutsideClick } from "utils/utils";

export const useContextMenu = () => {
    const [menu, setMenu] = useState<{ top: number; left: number } | null>(null);
    const ref = useRef<HTMLDivElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);

    const onContextMenuClick = useCallback((event) => {
        event.preventDefault();

        const pane = ref.current?.getBoundingClientRect();
        if (pane) {
            setMenu({
                top: event.clientY,
                left: event.clientX,
            });
        }
    }, []);

    const handleClick = useCallback(() => setMenu(null), []);

    useAnyOutsideClick(menuRef, handleClick);

    return {
        menu,
        setMenu,
        onContextMenuClick,
        ref,
        menuRef,
    };
};
